/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FormatMoney = {
    format: FormatMoney.format;
    decimals: number;
};
export namespace FormatMoney {
    export enum format {
        MONEY = 'money',
    }
}

